import { Col, Form, Input, message, Modal, Row, Select } from "antd";
import { Rule } from "antd/lib/form";
import { receptionistApi } from "api/receptionist.api";
import { roleApi } from "api/role.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Role } from "types/role";
import { Staff } from "types/staff";

const rules: Rule[] = [{ required: true }];
const { Option } = Select;

interface StaffForm extends Staff {
  roleId?: number;
}

export const ReceptionistModal = ({
  visible,
  status,
  staff,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  status: ModalStatus;
  staff: Partial<Staff>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<StaffForm>();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState<Role[]>([]);

  useEffect(() => {
    if (status == "create" && visible) {
      form.resetFields();
    }
  }, [visible, status]);

  useEffect(() => {
    fetchRole();
  }, []);

  const fetchRole = async () => {
    const res = await roleApi.findAll({ page: 1, limit: 0 });
    setRoles(res.data);
  };

  useEffect(() => {
    form.setFieldsValue({
      ...staff,
      roleId: staff.role?.id,
    });
    return () => {};
  }, [staff]);

  const createData = async () => {
    const valid = await form.validateFields();
    const { name, phone, username, password } = form.getFieldsValue();
    const data = {
      receptionist: {
        name,
        phone,
        username,
        password,
      },
    };

    setLoading(true);
    try {
      const res = await receptionistApi.create(data);
      message.success("Tạo mới thành công!");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const updateData = async () => {
    const valid = await form.validateFields();
    const { name, phone, username, password } = form.getFieldsValue();
    setLoading(true);
    try {
      const res = await receptionistApi.update(staff?.id || 0, {
        receptionist: {
          name,
          phone,
          username,
          password,
        },
      });
      message.success("Cập nhật thành công!");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={status == "create" ? "Tạo mới lễ tân" : "Cập nhật lễ tân"}
      style={{ top: 20 }}
      width={400}
      cancelText="Đóng"
      confirmLoading={loading}
      onOk={() => {
        status == "create" ? createData() : updateData();
      }}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Username" name="username" rules={rules}>
              <Input disabled={status == "update"} placeholder="" />
            </Form.Item>
          </Col>

          {status == "create" && (
            <Col span={24}>
              <Form.Item label="Mật khẩu" name="password" rules={rules}>
                <Input placeholder="" />
              </Form.Item>
            </Col>
          )}

          <Col span={24}>
            <Form.Item label="Họ tên" name="name" rules={rules}>
              <Input placeholder="" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Số điện thoại" name="phone" rules={rules}>
              <Input placeholder="" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>)
  );
};
